const ExploreFeedCard = ({ title, subtitle, meta, badge, chip }) => (
  <article className="explore-feed-card">
    <div className="explore-feed-card__body">
      {chip ? <span className="explore-feed-card__chip">{chip}</span> : null}
      <h6 className="explore-feed-card__title" title={title}>{title}</h6>
      {subtitle ? <p className="explore-feed-card__subtitle mb-0">{subtitle}</p> : null}
      {meta ? <p className="explore-feed-card__meta mb-0">{meta}</p> : null}
    </div>
    {badge != null && badge !== '' ? (
      <div className="explore-feed-card__badge">{badge}</div>
    ) : null}
  </article>
);

export default ExploreFeedCard;
